import {DatosInicioDetalleCFEDTO} from './DatosInicioDetalleCFEDTO';
import {DetalleCFEDTO} from '../DetalleCFEDTO';
import {TipoCodigoDTO} from '../TipoCodigoDTO';

export class DatosDetalleCFEDTO
{
  datosInicioDetalleCFEDTO: DatosInicioDetalleCFEDTO;
  detalleCFEDTO: DetalleCFEDTO;
  tiposCodigosIniciales: TipoCodigoDTO[];
  esRut: boolean;
}
